import { createFileRoute } from '@tanstack/react-router'
import { LicensesPage } from '../screens/Licenses'
import { RoleGuard } from '../components/RoleGuard'

function LicensesRoute() {
  return (
    <RoleGuard>
      <LicensesPage />
    </RoleGuard>
  )
}

export const Route = createFileRoute('/licenses')({
  component: LicensesRoute,
})
